import { useAppDispatch } from 'app/hooks';
import { fetchImportJobStatus } from 'common/services/api/Imports/Imports.thunk';
import { ImportJobStatus } from 'common/types/Entities';
import { useSnackbar } from 'notistack';

import { importAttemptCompleted } from '../utils/ImportsUtils';

export function usePollImportJobStatus(
    setImportStatus: (importStatus: ImportJobStatus) => void,
    handleImportDialogClose: () => void
) {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    function pollImportJobStatus(importJobId: string): void {
        dispatch(fetchImportJobStatus({ importJobId: importJobId }))
            .unwrap()
            .then((data) => {
                setImportStatus(data);
                if (!importAttemptCompleted(data.importStatusName)) {
                    setTimeout(() => pollImportJobStatus(importJobId), 1000);
                }
            })
            .catch(() => {
                enqueueSnackbar('Issue encountered while polling import job status.', { variant: 'error' });
                handleImportDialogClose();
            });
    }

    return { pollImportJobStatus };
}
